import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../components/LanguageSelector';
import Footer from '../components/Footer';
import '../components/Hero.css';

const SUPPORT_EMAIL = 'support@tenkusports.com';
const TERM_KEYS = ['who', 'venues', 'how', 'when', 'once', 'payment', 'changes'];
const STEP_KEYS = ['step1', 'step2', 'step3'];

const Refer = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('refer.pageTitle');
    return () => {
      document.title = 'Tenku';
    };
  }, [t]);

  const mailto = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(t('refer.mail.subject'))}&body=${encodeURIComponent(t('refer.mail.body'))}`;
  const shareUrl = `https://wa.me/?text=${encodeURIComponent(t('refer.share.message'))}`;

  return (
    <div className="bg-gray-900 min-h-screen text-white">
      <header className="bg-gray-900 py-4 px-6">
        <div className="max-w-6xl mx-auto flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-3">
            <img src="/img/brand/isotipo-web.png" alt="" className="h-10" />
            <img src="/img/brand/logotipo-web.png" alt="Tenku" className="h-6" />
          </Link>
          <LanguageSelector />
        </div>
      </header>

      <main>
        <section className="tk-hero">
          <div className="tk-hero-glow tk-hero-glow--accent" aria-hidden="true"></div>
          <div className="tk-hero-glow tk-hero-glow--violet" aria-hidden="true"></div>
          <div className="tk-hero-grid" aria-hidden="true"></div>

          <div className="tk-hero-center">
            <span className="tk-hero-badge">
              <span className="tk-hero-badge-dot" aria-hidden="true"></span>
              {t('refer.hero.badge')}
            </span>

            <h1 className="tk-hero-title">
              {t('refer.hero.title')}{' '}
              <span className="tk-hero-title-highlight">{t('refer.hero.titleHighlight')}</span>
            </h1>

            <p className="tk-hero-subtitle">{t('refer.hero.subtitle')}</p>

            <div className="tk-hero-ctas">
              <a href={shareUrl} target="_blank" rel="noopener noreferrer" className="tk-btn-primary">
                {t('refer.share.cta')}
              </a>
              <a href="#terms" className="tk-btn-ghost">
                {t('refer.hero.ctaTerms')}
              </a>
            </div>
          </div>
        </section>

        <section className="bg-gray-800 py-20 px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-14">{t('refer.how.title')}</h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              {STEP_KEYS.map((key, index) => (
                <div key={key} className="flex flex-col items-center text-center">
                  <div className="bg-brand text-white rounded-full w-16 h-16 flex items-center justify-center text-xl font-bold mb-4">
                    {index + 1}
                  </div>
                  <h3 className="text-xl font-semibold mb-3">{t(`refer.how.${key}.title`)}</h3>
                  <p className="text-gray-300 max-w-xs">{t(`refer.how.${key}.description`)}</p>
                </div>
              ))}
            </div>

            <div className="mt-16 max-w-2xl mx-auto bg-gray-900 border border-gray-700 rounded-2xl p-8 text-center">
              <h3 className="text-2xl font-bold mb-3">{t('refer.report.title')}</h3>
              <p className="text-gray-300 mb-6">{t('refer.report.description')}</p>
              <a href={mailto} className="tk-btn-ghost">
                {t('refer.report.cta')}
              </a>
            </div>
          </div>
        </section>

        <section id="terms" className="bg-gray-900 py-20 px-6">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-10">{t('refer.terms.title')}</h2>

            <ol className="space-y-6">
              {TERM_KEYS.map((key, index) => (
                <li key={key} className="flex gap-4">
                  <span className="text-brand font-bold text-lg w-6 shrink-0">{index + 1}.</span>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">{t(`refer.terms.${key}.title`)}</h3>
                    <p className="text-gray-300 leading-relaxed">{t(`refer.terms.${key}.body`)}</p>
                  </div>
                </li>
              ))}
            </ol>

            <div className="mt-14 flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a href={shareUrl} target="_blank" rel="noopener noreferrer" className="tk-btn-primary">
                {t('refer.share.cta')}
              </a>
              <a href={mailto} className="tk-btn-ghost">
                {t('refer.report.cta')}
              </a>
            </div>
            <div className="text-center">
              <p className="text-gray-400 mt-4">
                {t('refer.emailNote')}{' '}
                <a href={`mailto:${SUPPORT_EMAIL}`} className="text-brand">{SUPPORT_EMAIL}</a>
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Refer;
